import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";
import Link from "ds/components/Link";
import BadgeNext from "ds/components/BadgeNext";

import { ApiKeyViewRoleBinding } from "../../types";

type ApiKeyRolesListItemNameCellProps = {
  roleBinding: ApiKeyViewRoleBinding;
};

const ApiKeyRolesListItemNameCell = ({ roleBinding }: ApiKeyRolesListItemNameCellProps) => {
  const roleUrl = `/settings/role/${roleBinding.role.id}`;

  return (
    <Box fullWidth gap="large">
      {roleBinding.role.isSystem ? (
        <>
          <TextEllipsis tooltip={roleBinding.role.name} tooltipWidthMode="maxWidthSm">
            {(props) => (
              <Typography {...props} tag="p" variant="p-body3">
                {roleBinding.role.name}
              </Typography>
            )}
          </TextEllipsis>

          <BadgeNext type="strong" variant="blue" text="SYSTEM" />
        </>
      ) : (
        <Link size="small" variant="secondary" href={roleUrl}>
          {roleBinding.role.name}
        </Link>
      )}
    </Box>
  );
};

export default ApiKeyRolesListItemNameCell;
